const i18n = {
  'en-US': {
    'init.title': 'Enterprise Initialization',
    'init.subtitle': 'Import base data step by step, then activate your enterprise',
    'init.progress': 'Completed',
    'init.status.done': 'Completed',
    'init.status.skipped': 'Skipped',
    'init.status.pending': 'Pending',
    'init.status.processing': 'Processing',
    'init.status.failed': 'Failed, retry available',
    'init.status.locked': 'Locked',
    'init.action.use_default': 'Use System Default',
    'init.action.view_default': 'View Default',
    'init.action.upload_custom': 'Upload Custom',
    'init.action.activate': 'Activate Enterprise',
    'init.action.skip': 'Skip',
    'init.action.skip_confirm': 'Skip this step? You can still add the data later.',
    'init.title.default_preview': 'Default Values',
    'init.hint.all_done': 'All steps completed, the enterprise can be activated.',
    'init.hint.locked': 'Please complete the previous steps first.',
    'init.hint.upload': 'Download the template, fill in your data, then upload the .xlsx file.',
    'init.hint.default': 'Use the system default values, or download the template and upload your own data.',
    'init.hint.address': 'Fill in the default ship-to address of your enterprise.',
    'init.hint.failed': 'Import failed, please fix the data and upload again.',
    'init.hint.processing': 'File uploaded, parsing and validating in the background, please wait...',
    'init.hint.process_done': 'Import completed.',
    'init.hint.process_failed': 'Import failed.',
    'init.hint.process_timeout': 'Processing is taking longer than expected, please refresh later.',
    'init.step.tag_finance': 'Finance Tags',
    'init.step.tag_defect': 'QC Defect Tags',
    'init.step.tag_supplier': 'Supply Capability Tags',
    'init.step.material_category': 'Material Category',
    'init.step.material': 'Material Master Data',
    'init.step.bom': 'BOM',
    'init.step.supplier': 'Supplier',
    'init.step.address': 'Default Ship-to Address'
  },
  'zh-CN': {
    'init.title': '企业初始化',
    'init.subtitle': '按依赖顺序导入基础数据，全部完成后激活企业',
    'init.progress': '已完成',
    'init.status.done': '已完成',
    'init.status.skipped': '已跳过',
    'init.status.pending': '待处理',
    'init.status.processing': '处理中',
    'init.status.failed': '导入失败，可重新上传',
    'init.status.locked': '未解锁',
    'init.action.use_default': '使用系统默认值',
    'init.action.view_default': '查看默认值',
    'init.action.upload_custom': '上传自定义',
    'init.action.activate': '激活企业',
    'init.action.skip': '跳过',
    'init.action.skip_confirm': '确定跳过该步骤？相关数据可后期再补充。',
    'init.title.default_preview': '默认值预览',
    'init.hint.all_done': '全部步骤已完成，可以激活企业。',
    'init.hint.locked': '请先完成前面的步骤。',
    'init.hint.upload': '先下载模板，按模板格式填写数据后上传 .xlsx 文件。',
    'init.hint.default': '可直接使用系统默认值，也可下载模板上传自定义数据。',
    'init.hint.address': '填写企业默认收货地址。',
    'init.hint.failed': '导入失败，请修正数据后重新上传。',
    'init.hint.processing': '文件已上传，后台正在解析校验，请稍候……',
    'init.hint.process_done': '导入完成。',
    'init.hint.process_failed': '导入失败。',
    'init.hint.process_timeout': '处理时间较长，请稍后刷新查看结果。',
    'init.step.tag_finance': '财务标签',
    'init.step.tag_defect': '质检不良标签',
    'init.step.tag_supplier': '供货能力标签',
    'init.step.material_category': '物料分类',
    'init.step.material': '物料主数据',
    'init.step.bom': 'BOM',
    'init.step.supplier': '供应商',
    'init.step.address': '默认收货地址'
  }
};
export default i18n;